'use strict';

var _ = require('lodash');
var ChartFbcApplicabilityController = function ChartFbcApplicabilityController($q, $rootScope, $scope, chartFbcApplicabilityService) {
  var tooltipTemplate = _.template(require('../templates/chart-fbc-applicability-tooltip-template.html'));
  $scope.data = [];
  $scope.chartModel = {
    data: []
  };
  $scope.dateRange = '';
  var itemsBackgroundColors = ['#E67E29', '#804F92', '#75A01F', '#3399CC', '#206080'];
  var itemTextColors = ['#FFF', '#FFF', '#FFF', '#FFF', '#FFF'];
  function createClazzToColorMap(clazzes) {
    var result = {};
    _.forEach(clazzes, function (clazz) {
      result[clazz.label] = clazz.backgroundColorStyle['background-color'];
    });
    return result;
  }
  function createClazzTextToColorMap(clazzes) {
    var result = {};
    _.forEach(clazzes, function (clazz) {
      result[clazz.label] = clazz.textColor;
    });
    return result;
  }
  function addClazzToColorMapToModel() {
    var clazzToColorMap = createClazzToColorMap($scope.chartModel.clazzes);
    var clazzTextToColorMap = createClazzTextToColorMap($scope.chartModel.clazzes);
    _.forEach($scope.chartModel.data.grouped, function (group) {
      group.clazzToColorMap = clazzToColorMap;
      group.clazzTextToColorMap = clazzTextToColorMap;
    });
  }
  function setScopeAndRender(data, searchCriteria) {
    $scope.data = data;
    $scope.dateRange = chartFbcApplicabilityService.createDateRange(searchCriteria, data);
    $scope.chartModel.data = chartFbcApplicabilityService.createDataForChart(data, $scope.dateRange);
    $scope.chartModel.getXAxisValues = chartFbcApplicabilityService.getXAxisValues($scope.dateRange);
    $scope.chartModel.minRange = chartFbcApplicabilityService.getMinRangeSize($scope.chartModel.data);
    $scope.chartModel.clazzes = chartFbcApplicabilityService.createClazzes($scope.clazzes, itemsBackgroundColors, itemTextColors);
    addClazzToColorMapToModel();
    $scope.setChartVisibility(true);
    $scope.renderChart($scope.chartModel.data.grouped);
  }
  $scope.setViewportSelection = function (range) {
    var xAxisValues = chartFbcApplicabilityService.getXAxisValues($scope.dateRange);
    $scope.chartModel.getXAxisValues = xAxisValues.slice(range[0], range[1]);
    var dateRange = [$scope.chartModel.getXAxisValues[0], $scope.chartModel.getXAxisValues[$scope.chartModel.getXAxisValues.length - 1]];
    $scope.chartModel.data = chartFbcApplicabilityService.createDataForChart($scope.data, dateRange);
    $scope.chartModel.clazzes = chartFbcApplicabilityService.createClazzes($scope.clazzes, itemsBackgroundColors, itemTextColors);
    addClazzToColorMapToModel();
  };
  $scope.reloadChart = function (brushFilter) {
    $scope.clazzes = _.get(brushFilter, 'filterArguments[0][0].classes');
    $q.all(chartFbcApplicabilityService.getData()).then(_.spread(setScopeAndRender));
  };
  $scope.tooltipFormatter = function (d) {
    d = chartFbcApplicabilityService.prepareDataForTooltip(d);
    return tooltipTemplate({
      date: d.date,
      name: d.name,
      value: d.value
    });
  };
  $scope.tooltipFormatter.cssClass = 'fares-fbc-applicability-tooltip';
  $scope.createXAxisViewportFormatter = function () {
    var visibleTickValues = [];
    var formater = function formater(value, index) {
      return visibleTickValues[index];
    };
    formater.setVisibleTickValues = function (values) {
      visibleTickValues = values;
    };
    return formater;
  };
};
ChartFbcApplicabilityController.$inject = ['$q', '$rootScope', '$scope', 'ChartFbcApplicabilityService'];
module.exports = ChartFbcApplicabilityController;